import './BlockGridGallery.scss';
class BlockGridGallery {
    constructor( node ) {
        this.node = node;
    }
    init() {
        let t = this;

        if( typeof JSModules['PsInit'] != undefined && JSModules['PsInit'] ) {
            new JSModules['PsInit']( t.node );
        }

    }
}
JSModules[ 'BlockGridGallery' ] = BlockGridGallery;
export default BlockGridGallery;